import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/entities/entity/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    id: string;
}
const mutationFn = ({ parkingId, id }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, id }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteEntity };
